import { useCallback, useEffect, useState } from "react";
import { getProgrammeMates } from "../services/api";

/**
 * The mates training a programme together (#184): { code, owner, follows,
 * mates: [{ user_id, name, photo_url, owner, me, done, builds }] }, or null
 * when nobody else is on it. `reload` after joining or inviting.
 */
export default function useProgrammeMates(programmeId) {
  const [group, setGroup] = useState(null);
  const load = useCallback(async () => {
    if (!programmeId) {
      setGroup(null);
      return;
    }
    try {
      setGroup((await getProgrammeMates(programmeId)) || null);
    } catch {
      setGroup(null);
    }
  }, [programmeId]);
  useEffect(() => {
    load();
  }, [load]);
  return { group, reload: load };
}

/** Mates other than you who did this slot. */
export const matesWhoDid = (group, session) =>
  (group?.mates || []).filter(
    (m) => !m.me && m.done.some((d) => d.week === session.week_number && d.day === session.day_index),
  );

/** Sessions mates built themselves for this slot, newest owner first. */
export const matesBuilds = (group, session) =>
  (group?.mates || [])
    .filter((m) => !m.me)
    .flatMap((m) =>
      m.builds
        .filter((b) => b.week === session.week_number && b.day === session.day_index)
        .map((b) => ({ ...b, user_id: m.user_id, name: m.name })),
    );

/** A mate's first name, for "Built by Sam". */
export const mateName = (group, userId) => {
  const m = (group?.mates || []).find((x) => Number(x.user_id) === Number(userId));
  return m?.name ? m.name.split(" ")[0] : null;
};
